import React from 'react';
import HomeCarousel from '../HomeCarousel/HomeCarousel';
import HeroHeader from '../HeroHeader/HeroHeader';
import FeaturedArticlesSection from '../FeaturedArticlesSection/FeaturedArticlesSection';
import FeaturedCallOutsSection from '../FeaturedCallOutsSection/FeaturedCallOutsSection';

const HomePageWrapper = ({
    headline,
    introduction,
    slideshowCollection,
    children,
    featuredArticlesTitle,
    featuredArticlesCollection,
    callOutsCollection,
    externalLinks,
    metaDescription,
}) => {
    return (
        <>
            <HeroHeader
                title={headline}
                content={introduction}
                metaDescription={metaDescription}
            />
            <HomeCarousel articles={slideshowCollection.items} />
            {children}
            <FeaturedArticlesSection
                title={featuredArticlesTitle}
                articles={featuredArticlesCollection.items}
            />
            <FeaturedCallOutsSection callOuts={callOutsCollection.items} />
            {externalLinks}
        </>
    );
};

export default HomePageWrapper;
